import { AxiosPromise } from 'axios';
import { apiService } from '@app/services';

class VaultImportPasswordsService {
    readonly apiBase: string = '/api/directory/Vaults';

    sendImportEmail(emailAddress: string, handleError: Function, handleSuccess: Function): AxiosPromise {
        const apiUrl: string = `${this.apiBase}/SendImportEmail`;

        let jsonObject: any = {};
        jsonObject.Email = emailAddress;

        return apiService.post(apiUrl,
            jsonObject,
            { onError: handleError, onSuccess: handleSuccess })
            .catch();
    };

    getPasswordImporterUrl(handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService.get(`${this.apiBase}/GetPasswordImporterUrl`,
            { onError: handleError, onSuccess: handleSuccess })
            .catch();
    };

    importPasswords(fileData: object, encryptionKey: string, orgId: string, vaultId: string, vaultFolderId: string,
        handleError: Function, handleSuccess: Function): AxiosPromise {
        let headersToSend: any = {};

        headersToSend = {
            'Content-Type': 'multipart/form-data',
            'encryptionKey': encryptionKey,
            'orgId': orgId,
            'vaultId': vaultId,
            'vaultFolderId': vaultFolderId
        };

        return apiService.post(`${this.apiBase}/ImportPasswords`, fileData,
            {
                headers: headersToSend,
                onError: handleError,
                onSuccess: handleSuccess
            })
            .catch();
    }
}

export const vaultImportPasswordsService = new VaultImportPasswordsService();